import axios from "axios";
import initializeAxios from "../util/Axios";

class ContentServices {
    constructor() {
        initializeAxios();
    }

    async getContentKeys({ pageSize, pageIndex, searchTerm }) {
        const response = await axios.get("/api/contentKeys", {
            params: {
                pageSize,
                pageIndex,
                searchTerm
            }
        });
        return response;
    }

    async addContentKeys({ stringId, value }) {
        const response = await axios.post("/api/contentKeys/add", {
            stringId,
            value
        });
        return response;
    }

    async updateContentKeys({ contentKeysId, stringId, value }) {
        const response = await axios.put("/api/contentKeys/update", {
            contentKeysId,
            stringId,
            value
        });
        return response;
    }

    async deleteContentKeys(contentKeysId) {
        const response = await axios.put("/api/contentKeys/delete", {
            contentKeysId,
        });
        return response.data;
    }
}

export default new ContentServices();
